import { Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import useAPI from "../api/hooks/useAPI";
import useColors from "../api/hooks/useColors";
import CustomCopyButton from "./CustomCopyButton";
import LoadingIcon from "./LoadingIcon";

const PlatformUrls = ({ containerWidth = "450px" }) => {
  const { getPlatformUrl } = useAPI();
  const colors = useColors();
  const platformUrlQuery = useQuery({
    queryKey: ["platformUrl"],
    queryFn: getPlatformUrl,
    select: (response) => response.data,
  });

  const backendUrl = platformUrlQuery.data?.backend_url;
  const platformUrl = platformUrlQuery.data?.platform_url;

  if (!backendUrl || !platformUrl) {
    return null;
  }
  if (platformUrlQuery.isLoading) {
    return <LoadingIcon size={12} />;
  }
  if (platformUrlQuery.isError) {
    return <Typography color="error">Failed to load platform URLs</Typography>;
  }
  return (
    <>
      <Box>
        <Typography variant="subtitle1" gutterBottom>
          Breeze URLs
        </Typography>
        <Typography variant="body2" color={colors.text_secondary}>
          The Breeze platform communicates through the following domains.
          <br />
          Add them to your proxy or firewall allowlist to ensure full platform
          functionality.
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            padding: "12px 16px",
            border: "1px solid " + colors.enabled_stroke,
            borderRadius: "8px",
            width: containerWidth,
          }}
        >
          <Typography variant="body2" color={colors.text_secondary}>
            {platformUrl}
          </Typography>
          <CustomCopyButton copyTitle="Platform URL" copyText={platformUrl} />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            padding: "12px 16px",
            border: "1px solid " + colors.enabled_stroke,
            borderRadius: "8px",
            width: containerWidth,
          }}
        >
          <Typography variant="body2" color={colors.text_secondary}>
            {backendUrl}
          </Typography>
          <CustomCopyButton copyTitle="Backend URL" copyText={backendUrl} />
        </Box>
      </Box>
    </>
  );
};

export default PlatformUrls;
